var _linearGradient, _rect, _linearGradient2, _path, _path2, _rect2, _rect3, _linearGradient3, _path3, _linearGradient4, _path4, _rect4, _rect5, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Plumbing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GcQpCcd0xIAnzEfPRBH59a",
    x1: 16,
    x2: 21,
    y1: 15.5,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 9,
    x: 16,
    y: 11,
    fill: "url(#GcQpCcd0xIAnzEfPRBH59a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GcQpCcd0xIAnzEfPRBH59b",
    x1: 4,
    x2: 43,
    y1: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GcQpCcd0xIAnzEfPRBH59b)",
    d: "M43,40H33v-8c0-1.105-0.895-2-2-2H5c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h26 c6.627,0,12,5.373,12,12V40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M31,39v-1c0-0.552,0.448-1,1-1h12c0.552,0,1,0.448,1,1v1c0,0.552-0.448,1-1,1H32 C31.448,40,31,39.552,31,39z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 10,
    x: 9,
    y: 20,
    opacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10,
    x: 9.5,
    y: 20,
    opacity: 0.07
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GcQpCcd0xIAnzEfPRBH59c",
    x1: 8.537,
    x2: 26.078,
    y1: 15.037,
    y2: 32.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#9dfbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8bf1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#6ee0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63daff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GcQpCcd0xIAnzEfPRBH59c)",
    d: "M24.801,33H12.199C10.985,33,10,32.015,10,30.801V19.199C10,17.985,10.985,17,12.199,17 h12.602C26.015,17,27,17.985,27,19.199v11.602C27,32.015,26.015,33,24.801,33z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GcQpCcd0xIAnzEfPRBH59d",
    x1: 15,
    x2: 22,
    y1: 11.5,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GcQpCcd0xIAnzEfPRBH59d)",
    d: "M18.5,15L18.5,15c-1.933,0-3.5-1.567-3.5-3.5v0C15,9.567,16.567,8,18.5,8h0 c1.933,0,3.5,1.567,3.5,3.5v0C22,13.433,20.433,15,18.5,15z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 16,
    y: 11,
    opacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 3.5,
    x: 16,
    y: 11,
    opacity: 0.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M28.09,14H8.91C8.407,14,8,13.593,8,13.09v-1.18C8,11.407,8.407,11,8.91,11h19.18 c0.503,0,0.91,0.407,0.91,0.91v1.18C29,13.593,28.593,14,28.09,14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Plumbing);
export default __webpack_public_path__ + "static/media/icons8-plumbing.f1546bc06b43280dd0259069b8272307.svg";
export { ForwardRef as ReactComponent };